import React from 'react';
import cx from 'classnames';

import FormattedMessage from 'components/formatted-message';

import styles from '../search-dropdown.module.css';

export type SearchFilter = 'all' | 'players' | 'teams';

// The values of FAVORITE_FILTERS of the home dashboard; the labels are home.favorites.<filter>
const FILTERS: SearchFilter[] = ['all', 'players', 'teams'];

type FilterPillsProps = {
    value: SearchFilter;
    onChange: (value: SearchFilter) => void;
    /** shown after the label: the number of the found items */
    counts?: Record<SearchFilter, number>;
};

/** All / Players / Teams, as on the home favorites panel */
const FilterPills = ({ value, onChange, counts }: FilterPillsProps) => (
    <div className={styles.filterPills}>
        {FILTERS.map(filter => (
            <button
                key={filter}
                type="button"
                className={cx(styles.filterPill, { [styles.filterPillActive]: filter === value })}
                onClick={() => onChange(filter)}
            >
                <FormattedMessage id={`home.favorites.${filter}`} />
                {counts ? ` ${counts[filter]}` : null}
            </button>
        ))}
    </div>
);

export default FilterPills;
